
function randomInteger(max) {
    return Math.floor(Math.random()*(max + 1));
}

function randomRgbColor() {
    let r = randomInteger(255);
    let g = randomInteger(255);
    let b = randomInteger(255);
    return [r,g,b];
}

function randomRgbColorHex() {
    let [r,g,b] =randomRgbColor();
    let hr = r.toString(16).padStart(2, '0');
    let hg = g.toString(16).padStart(2, '0');
    let hb = b.toString(16).padStart(2, '0');
    return "#" + hr + hg + hb;
}

// Force a hex value to have 2 characters
function pad2(c) 
{
    return c.length == 1 ? '0' + c : '' + c;
}

function rgbToHex(r, g, b) 
{
	// expects rgb channel values in range [0, 255]
	return '#' + 
		[r, g, b].map(x => Math.floor(x).toString(16).padStart(2, '0')).join('').toUpperCase();
}

function parseIntFromHex(val) {
    return parseInt(val, 16);
}

function parseFracFromHex(h) {
    return (parseIntFromHex(h) / 255);
}

function hexToRgb(hexString)
{
	if (hexString.charAt(0) == '#') {
		hexString = hexString.substring(1);
	}
	let dpc = hexString.length / 3; // digits per channel
    r = parseIntFromHex(hexString.substring(0*dpc, 1*dpc));
    g = parseIntFromHex(hexString.substring(1*dpc, 2*dpc));
    b = parseIntFromHex(hexString.substring(2*dpc, 3*dpc));
    return [r, g, b];
}

function hexToRgbFrac(hexString)
{
	if (hexString.charAt(0) == '#') {
		hexString = hexString.substring(1);
	}
	let dpc = hexString.length / 3; // digits per channel
    r = parseFracFromHex(hexString.substring(0*dpc, 1*dpc));
    g = parseFracFromHex(hexString.substring(1*dpc, 2*dpc));
    b = parseFracFromHex(hexString.substring(2*dpc, 3*dpc));
    return [r, g, b];
}

function v3mag(v)
{
	return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
}

function v3Normalize(v)
{
	mag = v3mag(v);
	mag = Math.max(mag, 0.001);
	result = [v[0] / mag, v[1] / mag, v[2] / mag];
	return result;
}

function v3Scale(v, f)
{
	return [v[0] * f, v[1] * f, v[2] * f];
}

function v3Clamp(v, clamp)
{
	vc0 = Math.max(0, Math.min(v[0], clamp));
	vc1 = Math.max(0, Math.min(v[1], clamp));
	vc2 = Math.max(0, Math.min(v[2], clamp));
	return [vc0, vc1, vc2];
}

function blendColorsHalfway(rgb00, rgb01)
{
	// represent 2 RGB colors as 3D vectors and return halfway vector
	// expects and returns rgb channel values in range [0, 255]

	// console.log("blendColorsHalfway()");
	vec00 = [rgb00[0] / 255.0, rgb00[1] / 255.0, rgb00[2] / 255.0];
	vec01 = [rgb01[0] / 255.0, rgb01[1] / 255.0, rgb01[2] / 255.0];
	// vec00 = rgb00;
	// vec01 = rgb01;
	// calc input vector lengths
	vec00Mag = v3mag(vec00);
	vec01Mag = v3mag(vec01);
	vec00Mag = Math.max(vec00Mag, 0.001);
	vec01Mag = Math.max(vec01Mag, 0.001);
	// normalize  input vectors
	vec00Norm = v3Normalize(vec00);
	vec01Norm = v3Normalize(vec01);
	// calc halfway vector
	vMidRaw = [vec01Norm[0] + vec00Norm[0], vec01Norm[1] + vec00Norm[1], vec01Norm[2] + vec00Norm[2]];
	// console.log("vMidRaw " + str(vMidRaw));
	// set halfway vector length to average of input vector lengths
	vMidNorm = v3Normalize(vMidRaw);
	// console.log("vMidNorm " + vMidNorm);
	vMidMag = (vec01Mag + vec00Mag)/2.0;
	vMid = v3Scale(vMidNorm, vMidMag);
	// console.log("vMid " + vMid);
	// clamp result to unit rgb space
	vMidClamped = v3Clamp(vMid, 1.0);

	rgbMid = v3Scale(vMidClamped, 255.0);
    // rgbMid = vMidClamped;
	// hex = rgbToHex(rgb[0], rgb[1], rgb[2]);
    // console.log(rgbMid);

	// console.log("rgb00 " + rgb00 + " rgb01 " + rgb01 + " rgbMid " + rgbMid);
	return rgbMid;
}

//////////////

function sortIndicesFan(iStart, length, exceptStart=false)
{
	// console.log("sortIndicesFan() iStart=" + iStart + " length=" + length);
	if (length == 0){ return []; }

	let result = [iStart];
	let dist = 1;
	while(result.length < length){
		iMin = iStart - dist;
		iMax = iStart + dist;
		if (iMin >= 0) { result.push(iMin); }
		if (iMax < length) { result.push(iMax); }
		dist++;
	}
	if (exceptStart) { result.shift(); }
	return result;
}

function sortIndicesCycle(iStart, length, exceptStart=false)
{
	if (length == 0){ return []; }
	
	let result = exceptStart ? [] : [iStart];
	for (let c = 1; c < length; c++){
		result.push((c + iStart)%length);
	}
	return result;
}

function isValidHexCode(strHex) 
{
	let str = strHex;
    if (str[0] == '#') {
        str = str.substring(1);
	}

    if (!(str.length == 3 || str.length == 6)) {
        return false;
	}

	const charCode_0 = '0'.charCodeAt(0);
	const charCode_9 = '9'.charCodeAt(0);
	const charCode_a = 'a'.charCodeAt(0);
	const charCode_f = 'f'.charCodeAt(0);
	const charCode_A = 'A'.charCodeAt(0);
	const charCode_F = 'F'.charCodeAt(0);
    for (let i = 0; i < str.length; i++) {
		let charCode = str[i].charCodeAt(0);
        if (!((charCode >= charCode_0 && charCode <= charCode_9)
            || (charCode >= charCode_a && charCode <= charCode_f)
            || (charCode >= charCode_A && charCode <= charCode_F))){
	        return false;
		}
	}

    return true;
}

function getNormalizedHexCode(hexCode) 
{
    console.log("getNormalizedHexCode() " + hexCode);
	if (hexCode.length == 0) { 	
		console.log("color code invalid 1: " + hexCode);
		return false;
	}

	let hexCodeRaw = "";
    if (hexCode.length == 3 || hexCode.length == 6){
		hexCodeRaw = hexCode;
	} else if ((hexCode.length == 4 || hexCode.length == 7) && hexCode[0] == '#') {	
		hexCodeRaw = hexCode.substring(1);
	} else {
		console.log("color code invalid 2: " + hexCode);
		return false;
	}

	const charCode_0 = '0'.charCodeAt(0);
	const charCode_9 = '9'.charCodeAt(0);
	const charCode_a = 'a'.charCodeAt(0);
	const charCode_f = 'f'.charCodeAt(0);
	const charCode_A = 'A'.charCodeAt(0);
	const charCode_F = 'F'.charCodeAt(0);
    for (let i = 0; i < hexCodeRaw.length; i++) {
		let charCode = hexCodeRaw[i].charCodeAt(0);
        if (!((charCode >= charCode_0 && charCode <= charCode_9)
            || (charCode >= charCode_a && charCode <= charCode_f)
            || (charCode >= charCode_A && charCode <= charCode_F))){
			console.log("color code invalid 3: " + hexCode);
	        return false;
		}
	}

	if (hexCodeRaw.length == 3){
		hexCodeRaw = hexCodeRaw[0] + hexCodeRaw[0] + hexCodeRaw[1] + hexCodeRaw[1] + hexCodeRaw[2] + hexCodeRaw[2];
	}

    return "#" + hexCodeRaw.toUpperCase();
}


function getColorContrast(colorHEX)
{
    const [r, g, b] = hexToRgbFrac(colorHEX);
    const colBrightness = r + g + b;
    colorContrast = colBrightness > 1.5 ? "#000000" : "#FFFFFF";
    return colorContrast;
}

function zenCCadjustSwatchStyles(elem, colBgHex)
{
    // console.log("zenCCadjustSwatchStyles()");
    let [colTypo, visBorder] = zenCCgetSwatchStyles(colBgHex);
    elem.style.backgroundColor = colBgHex; 
    elem.style.border = visBorder ? "1px solid #000" : 0;
    elem.style.color = colTypo;
}


function zenCCgetSwatchStyles(colSwatchHEX)
{
    // console.log("zenCCgetSwatchStyles()");
    colorText = getColorContrast(colSwatchHEX);
    visBorder = colorText == "#000000" ? true : false;
    return [colorText, visBorder];
}